<div *ngIf="isLoaded">
  <div class="rejection-details" *ngIf="taskStatus && ['Rejected'].includes(taskStatus)">
    <app-rejection-details [supplierCode]='supplierCode' [rejectionDetails]='rejectionDetails'></app-rejection-details>
  </div>
  <br />
  <tsl-alert *ngIf="contextVerbiage" icon="info_blue" style="color: #3E6AE1" status="primary">{{
    translate.get(contextVerbiage.bank.description) }}
  </tsl-alert>
  <div *ngIf="taskStatus && ['New', 'Rejected', 'Pending'].includes(taskStatus); else OtherContact">
    <ng-container *ngIf="requestType || isReactivation || enableExistSelection">
      <ng-container *ngIf="['nameOrTINChange'].includes(requestType); else singleSelectForm">
        <app-exist-select #selectTable
            [columns]="displayedColumns"
            [masterData]="tableData"
            [requestType]="requestType"
            (onSelect)="onSelected($event)"
            (onEdit)="onEdit($event)"
            (onView)="onView($event)"
            (onDelete)="onDelete($event)"
            (onAdd)="onAdd($event)"
        ></app-exist-select>
        <p class="select-table-error-message" *ngIf="!isValidSelectTable">{{ this.translate.get(tableErrorMessage) }}</p>
        <div class="entity-mapping-container">
          <app-entity-mapping #entityMapping [masterData]="entityMappings" [options]="entityMappingOptions" [itemType]="'Bank'"></app-entity-mapping>
        </div>
      </ng-container>
      <ng-template #singleSelectForm>
        <div *ngIf="isReactivation || enableExistSelection">
          <app-exist-select #selectTable
            [columns]="displayedColumns"
            [masterData]="tableData"
            [requestType]="requestType"
            (onSelect)="onSelected($event)"
            (onPrimarySelect)="onPrimarySelected($event)"
            (onEdit)="onEdit($event)"
            (onFileUpload)="onFileUpload($event)"
          ></app-exist-select>
          <p class="select-table-error-message" *ngIf="!isValidSelectTable">{{ this.translate.get(tableErrorMessage) }}</p>
        </div>
        <br/>
        <p class="new-form-title" *ngIf="(isReactivation || enableExistSelection) && isCreateNew" i18n="@@reactivationCreateNewInformationMessage" t="reactivationCreateNewInformationMessage">Please provide new information for your Supplier Profile setup with Tesla.</p>
        <bank-edit [hidden]="(isReactivation || enableExistSelection) && !isCreateNew" #bankEditComponent [tsl-supplierBank]="supplierBank" [tsl-readOnly]="false"
          [tsl-generalSettings]="generalSettings$ | async" [tsl-countries]="countries$ | async"
          [tsl-currencies]="currencies$ | async" [tsl-bankConfiguration]="bankConfig$ | async" [tsl-hideCancelButton]="true"
          [tsl-legalName]="legalName"
          [tsl-hideSaveButton]="true" [tsl-supplierBankDocType]="requiredDocuments?.DocumentType"
          [tsl-intermediaryPaymentOrigins]="intermediaryPaymentOrigins$ | async" [tsl-showPaymentOriginControl]="false"
          (tsl-onPaymentOriginChange)="onPaymentOriginChangedEvent($event)"
          [tsl-hideDocumentSection]="requiredDocuments == null" [tsl-supplierCode]="supplierCode"
          (tsl-stepChanged)="setErrorMessage()" (tsl-onCountryChange)="countryChangeEventHandler($event)"
          (tsl-onVerify)="verifyEventHandler($event.supplierBank)"
          (tsl-onSubmit)="submitEventHandler($event.supplierBank, $event.uploadFiles, $event.isPartialSave, $event.isBankDataChanged)"
          (tsl-onSave)="saveEventHandler($event.supplierBank)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)"
          [tsl-isSupplierTask]="false"
          [tsl-supplierRequestType]="requestType">
        </bank-edit>
      </ng-template>
    </ng-container>
    
    <div *ngIf="!isSidePanelMode" class="button-container">
      <!-- <button class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit(true)" i18n="@@Save" t="Save">Save</button> -->
      <button *ngIf="taskStatus && ['New', 'Rejected'].includes(taskStatus)" class="action-btn" tsl-button size="small"
        color="blue" filled (click)="onSubmit()" i18n="@@Submit" t="Submit">Submit</button>
    </div>
  </div>
  <ng-template #OtherContact>
    <h3>
      <span i18n="@@taskCompleteRedirect" t="taskCompleteRedirect">Task is already completed please go back to home
        page.</span>
      <a i18n="@@clickHere" t="clickHere" href="javascript:void(0)" (click)="navigateToHome()">Click Here</a>
    </h3>
  </ng-template>
</div>
